import { render, staticRenderFns } from "./ErreurPaiement.vue?vue&type=template&id=0378db24"
import script from "./ErreurPaiement.vue?vue&type=script&lang=js"
export * from "./ErreurPaiement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports